(function () {
    const wrapTable = {
        init() {
            this.wrapTable();
        },

        wrapTable() {
            const tables = document.querySelectorAll('table');

            tables.forEach((table) => {
                if (table.closest('.table-wrapper')) {
                    return;
                }

                const wrapper = document.createElement('div');
                wrapper.className = 'table-wrapper';

                const parent = table.parentElement;

                parent.insertBefore(wrapper, table);
                wrapper.appendChild(table);
            });
        }
    };
    addEventListener('DOMContentLoaded', function () {
        if (document.querySelector('table')) {
            wrapTable.init();
        }
    });
})();